// @flow
import React from 'react';

import './RadioInput.less';

const RadioInput = ({name, value, checked, onChange}) => {

    return <div className={'bil-radio-input'}>
                <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
                <span className={'bil-radio-input__button'}></span>
            </div>;

};

export default RadioInput;